import { SpinnerIcon } from "../../assets/Icons/icons";

const Loader = ({ size = "md", color = "text-primary", className = "" }) => {
  const sizes = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
  };

  const sizeClass = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <SpinnerIcon className={`animate-spin ${sizeClass} ${color}`} />
    </div>
  );
};

export default Loader;
